
























































































































import { QuotationCustomDutyItem } from "@/model/component.model";
import { isEqual, cloneDeep } from "lodash";
import Vue from "vue";
import { Debounce } from "vue-debounce-decorator";
import { Component, Prop, Watch } from "vue-property-decorator";

import DecimalNumber from "@/components/shared/DecimalNumber.vue";
import { Validations } from "vuelidate-property-decorators";
import { minValue, required } from "vuelidate/lib/validators";

@Component({
  components: {
    DecimalNumber
  }
})
export default class CustomDutyItem extends Vue {
  @Prop({ type: Object, required: true }) propItem: QuotationCustomDutyItem;
  item: QuotationCustomDutyItem = {
    category: "",
    hsCode: "",
    singleValue: 0,
    description: "",
    gender: "",
    material: "",
    weight: 0,
    quantity: 1,
    isValid: false,
    totalValue: 0
  };

  example = 33;

  @Validations()
  validations() {
    return {
      item: {
        description: {
          required
        },
        weight: {
          required,
          minValue: minValue(0.1)
        },
        singleValue: {
          required,
          minValue: minValue(0.1)
        },
        quantity: {
          required
        }
      }
    };
  }

  @Watch("propItem", { deep: true, immediate: true })
  onItemChange() {
    if (isEqual(this.item, this.propItem)) return;
    this.item = cloneDeep(this.propItem);
  }

  @Debounce(500)
  @Watch("item", { deep: true })
  onModelUpdate(value: QuotationCustomDutyItem) {
    value.isValid = !this.$v.$invalid;
    value.totalValue = value.singleValue * value.quantity;
    this.$emit("syncModel", cloneDeep(value));
  }

  deleteItem() {
    this.$emit("delete");
  }
}
